// operations
// 1つ以上の action を組み合わせたもの。
// 個別の action は単純なままに、必要に応じて複雑な operations を作成できる。
// redux-thunkなどのミドルウェアはここで使う。
// import {push} from 'connected-react-router';
// import axios from 'axios';
import {commonOperations} from '../common';
import {
  changeTheme,
  doLogin,
  doLogout,
  getUserInfo,
  setMenuItems,
  expandedMenuItems,
} from './actions';

// API_URL取得
import {Amplify, Auth} from 'aws-amplify'; // Amplify
import AWS from 'aws-sdk'; // AWS-SDK
import conf from './../../config/config.js';
import {clearSession} from '../../common/Session.js';
import {getCurrentUser} from '../common/operations.js';
import {getRequest} from '../../common/backend.js';
import {HttpStatusCode} from 'axios';

if (conf.amplify_conf) {
  Amplify.configure(conf.amplify_conf);
  AWS.config.region = conf.region;
}

// storeリセット
const doClear = (info) => {
  return (dispatch) => {
    dispatch(doLogout());
  };
};

/**
 * Cognito認証ログイン。
 *
 * @return {'OK'|'NO_LOGIN'|'SYS_ERROR'} 実行結果
 */
const doLoginOperation = () => {
  return async (dispatch, getState) => {
    const {form} = getState();
    let values = form.Login.values;

    // 入力値が取得できない場合は入力エラー
    if (!values?.username || !values.password) {
      console.error('Get Values Error.');
      return 'NO_LOGIN';
    }

    const userName = values.username ? values.username.trim() : null;
    const password = values.password ? values.password.trim() : null;

    // トリム後のユーザID/パスワードが空の場合はエラー
    if (!userName || !password) {
      console.error('ID/Password Empty Error.');
      return 'NO_LOGIN';
    }

    try {
      console.log('ログイン情報取得');
      dispatch(commonOperations.startRequest());
      const retLogin = await Auth.signIn(userName, password);
      dispatch(commonOperations.endRequest());

      console.log('retLogin:', retLogin);

      const attributes = retLogin.attributes;

      const corpCd = attributes ? attributes['custom:corpCd'] : null;

      const sub = attributes ? attributes.sub : null;

      const session = retLogin.signInUserSession;
      const idToken = session ? session.idToken.jwtToken : null;

      const loginInfo = {
        isLoggedIn: true,
        idToken: idToken,
        cognitoUser: sub,
        corpCd: corpCd,
        userId: retLogin.username,
      };

      dispatch(doLogin(loginInfo));

      if (retLogin.challengeName === 'NEW_PASSWORD_REQUIRED') {
        // 仮パスワードログイン時はAuth.signInの結果を保持
        loginInfo['signInUser'] = retLogin;
        return 'REDIRECT_NEW_PASSWORD';
      } else {
        return 'OK';
      }
    } catch (err) {
      console.log('signIn err:', err);
      dispatch(commonOperations.endRequest());
      if (err.code === 'UserNotFoundException' || err.code === 'NotAuthorizedException') {
        return 'NO_LOGIN';
      } else if (err.code === 'PasswordResetRequiredException') {
        return 'RESET_REQUIRE';
      } else {
        return 'SYS_ERROR';
      }
    }
  };
};

const sendAuthenticationCodeOperation = (username) => {
  console.log('パスワードリセット(認証コード送付)');

  return async (dispatch) => {
    try {
      dispatch(commonOperations.startRequest());

      const result = await Auth.forgotPassword(username);
      console.dir(result);
      return 'OK';
    } catch (err) {
      console.log('forgotPassword err:', err);

      if (err.code === 'UserNotFoundException') {
        // ユーザIDが誤っていた場合は成功扱い
        return 'OK';
      } else if (err.code === 'NotAuthorizedException') {
        // 未認証のユーザの場合は成功扱い
        return 'OK';
      } else if (err.code === 'LimitExceededException') {
        // リセット回数過多
        return 'LIMIT_EXCEED';
      } else {
        return 'SYS_ERROR';
      }
    } finally {
      dispatch(commonOperations.endRequest());
    }
  };
};

// パスワードリセット(パスワード更新)
const doPasswordResetOperation = (userName, code, password) => {
  console.log('パスワードリセット(パスワード更新)');
  return async (dispatch) => {
    try {
      dispatch(commonOperations.startRequest());

      await Auth.forgotPasswordSubmit(userName, code, password);
      return 'OK';
    } catch (err) {
      console.error(err);

      if (err.code === 'CodeMismatchException') {
        return 'CODE_ERROR';
      } else if (err.code === 'ExpiredCodeException') {
        return 'CODE_EXPIRED';
      } else if (err.code === 'PasswordHistoryPolicyViolationException') { // 2024.12.24 add
        return 'HISTORY_PASSWORD';
      } else {
        return 'SYS_ERROR';
      }
    } finally {
      dispatch(commonOperations.endRequest());
    }
  };
};

/**
 * 仮パスワードでログイン時のパスワード変更
 * @param {Auth.CognitoUser} user
 * @param {string} password 新しいパスワード
 * @return {function}
 */
const doCompletePassword = (user, password) => {
  return async (dispatch) => {
    try {
      dispatch(commonOperations.startRequest());
      await Auth.completeNewPassword(user, password);
      return 'OK';
    } catch (err) {
      console.error(err);
      if (err.code) {
        return err.code;
      }

      return 'SYS_ERROR';
    } finally {
      dispatch(commonOperations.endRequest());
    }
  };
};

/**
 * パスワードの変更
 * @param {string} oldPassword 現在のパスワード
 * @param {string} newPassword 新しいパスワード
 * @return {function}
 */
const doChangePassword = (oldPassword, newPassword) => {
  return async (dispatch) => {
    try {
      dispatch(commonOperations.startRequest());
      const user = await Auth.currentAuthenticatedUser();
      await Auth.changePassword(user, oldPassword, newPassword);
      return 'OK';
    } catch (err) {
      console.error(err);
      if (err.code) {
        return err.code;
      }

      return 'SYS_ERROR';
    } finally {
      dispatch(commonOperations.endRequest());
    }
  };
};

/**
 * ログアウト処理の実行。
 *
 * セッションストレージのクリアと、ログイン情報のクリアを行う。
 *
 * @param {Function} dispatch Dispatch
 */
const logoutFunc = (dispatch) => {
  clearSession();
  dispatch(doLogout());
};

// ログアウト（storeリセット）
const doLogoutOperation = (info) => {
  // logout api 呼び出し
  // ログイン画面
  return (dispatch) => {
    logoutFunc(dispatch);
    // Amplify
    console.log('###signOut');
    Auth.signOut()
        .then((data) => console.log('data:', data))
        .catch((err) => console.log('err:', err));
    // dispatch(push('/login'));
  };
};


// サインアウト(ログイン画面遷移なし)
const doSignOutOperation = () => {
  console.log('サインアウト...');

  return async (dispatch) => {
    logoutFunc(dispatch);
    try {
      await Auth.signOut();
    } catch (err) {
      console.error(err);
    }
  };
};

/**
 * ユーザー情報取得。
 * @param {boolean} force 強制取得フラグ
 * @return {string} 取得結果。成功の場合'OK'、失敗の場合エラーコード
 */
const getUserInfoOperation = (force = false) => {
  return async (dispatch, getState) => {
    console.log('ユーザー情報取得');

    const {auth} = getState();

    // すでに取得済の場合は処理終了
    if (!force && auth.userInfo) {
      console.log('データ取得済のため終了');
      console.groupEnd();
      return 'OK';
    }

    try {
      const userInfo = await getCurrentUser();

      // ユーザ情報をストアへ登録
      dispatch(getUserInfo(userInfo));
    } catch (err) {
      return 'ERROR';
    }
    console.groupEnd();
    return 'OK';
  };
};

// トークン更新
const doRefreshTokenOperation = () => {
  return async (dispatch, getState) => {
    const {auth} = getState();
    const loginInfo = auth.loginInfo;
    if (loginInfo) {
      try {
        console.log('トークン更新');
        const currentSession = await Auth.currentSession();
        const idToken = currentSession.getIdToken().getJwtToken();
        // IDトークン更新
        loginInfo.idToken = idToken;
        dispatch(doLogin(loginInfo));
      } catch (err) {
        console.log(err);
      }
    }
  };
};

/**
 * メニュー項目の取得。
 *
 * @param {boolean} [force] 強制取得フラグ
 * @return {function} 取得処理
 */
const doGetMenuItemsOperation = (force = false) => {
  return async (dispatch, getState) => {
    return await _getMenuItems(dispatch, getState, force);
  };
};

/**
 * メニュー項目の取得 実行。
 *
 * @param {function} dispatch ディスパッチ
 * @param {function} getState State取得
 * @param {boolean} [force] 強制取得フラグ
 * @return {Promise<object[]>} メニュー項目一覧
 */
const _getMenuItems = async (dispatch, getState, force) => {
  console.group('メニュー項目取得');
  const {auth} = getState();

  // すでに取得済の場合は処理終了
  if (!force && auth.menuItems) {
    console.debug('データ取得済のためストアの情報を返却');
    console.groupEnd();
    return auth.menuItems;
  }

  // APIを実行してメニュー項目を取得
  const response = await getRequest('scz1002/get-menu-items', {});
  if (response.status != HttpStatusCode.Ok) {
    console.groupEnd();
    return [];
  }

  const menuItems = response.data.menuItems;
  dispatch(setMenuItems(menuItems));

  // メニュー開閉状態をリセットする
  dispatch(expandedMenuItems([]));

  console.groupEnd();
  return menuItems;
};

/**
 * メニュー開閉状態の設定。
 *
 * @param {string[]} [nodeIds] メニューが開かれた項目のnodeId一覧
 * @return {Promise<void>} 結果
 */
const doSetExpandedMenuItems = (nodeIds) => {
  return (dispatch) => {
    dispatch(expandedMenuItems(nodeIds));
  };
};

export default {
  changeTheme,
  doLoginOperation,
  sendAuthenticationCodeOperation,
  doPasswordResetOperation,
  doCompletePassword,
  doChangePassword,
  doLogoutOperation,
  doSignOutOperation,
  getUserInfoOperation,
  doRefreshTokenOperation,
  doClear,
  doGetMenuItemsOperation,
  doSetExpandedMenuItems,
};
